/*
 * Calculates and fills in an estimated delivery date for elements marked
 * with [data-auto-delivery-date].
 *
 * Logic: ship date + 1.5 business days, rounded up to 2 business days.
 * "Business day" here excludes Sundays and German public (federal) holidays.
 * Saturdays count as business days.
 */
(function () {
  "use strict";

  var GERMAN_MONTHS = [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"
  ];

  var BUSINESS_DAYS_TO_ADD = 2; // ceil(1.5)

  function toDateKey(date) {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
  }

  function easterSunday(year) {
    // Anonymous Gregorian algorithm (Meeus/Jones/Butcher)
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function germanHolidays(year) {
    var easter = easterSunday(year);
    var holidays = [
      new Date(year, 0, 1),          // Neujahr
      addDays(easter, -2),           // Karfreitag
      addDays(easter, 1),            // Ostermontag
      new Date(year, 4, 1),          // Tag der Arbeit
      addDays(easter, 39),           // Christi Himmelfahrt
      addDays(easter, 50),           // Pfingstmontag
      new Date(year, 9, 3),          // Tag der Deutschen Einheit
      new Date(year, 11, 25),        // 1. Weihnachtsfeiertag
      new Date(year, 11, 26)         // 2. Weihnachtsfeiertag
    ];

    var keys = {};
    holidays.forEach(function (d) {
      keys[toDateKey(d)] = true;
    });
    return keys;
  }

  var holidayCache = {};
  function isHoliday(date) {
    var year = date.getFullYear();
    if (!holidayCache[year]) {
      holidayCache[year] = germanHolidays(year);
    }
    return !!holidayCache[year][toDateKey(date)];
  }

  function isBusinessDay(date) {
    // Sunday excluded, Saturday counts as a business day.
    return date.getDay() !== 0 && !isHoliday(date);
  }

  function calculateDeliveryDate() {
    var current = new Date();
    current.setHours(0, 0, 0, 0);

    // Determine the effective ship date: today if it's a business day,
    // otherwise roll forward to the next business day.
    while (!isBusinessDay(current)) {
      current = addDays(current, 1);
    }

    // Add the required number of business days from the ship date.
    var added = 0;
    while (added < BUSINESS_DAYS_TO_ADD) {
      current = addDays(current, 1);
      if (isBusinessDay(current)) {
        added++;
      }
    }

    return current;
  }

  function formatGermanDate(date) {
    return date.getDate() + ". " + GERMAN_MONTHS[date.getMonth()];
  }

  function init() {
    var elements = document.querySelectorAll("[data-auto-delivery-date]");
    if (!elements.length) return;

    var deliveryDate = calculateDeliveryDate();
    var formatted = formatGermanDate(deliveryDate);

    elements.forEach(function (el) {
      var prefix = el.dataset.prefix || "";
      el.textContent = prefix ? prefix + " " + formatted : formatted;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
